const defaultAttributes = `
attribute vec3 aVertexPosition;
attribute vec2 aTextureCoord;
`;
export default defaultAttributes.replace(/\n/g, '');